import getters from './getters';
import actions from './actions';
import mutations from './mutations';
const state = {
  current: sessionStorage.getItem('currentLanguage', getters.browserLanguage())
};
export default {
  state,
  getters,
  actions,
  mutations
};
